function pushVariant(variants, props, style) {
  variants.push({
    props,
    style: typeof style === "function" ? style : () => style,
  });
}

function pushWithAliases(variants, canonicalProps, legacyPropsList, style) {
  pushVariant(variants, canonicalProps, style);
  legacyPropsList.forEach((props) => pushVariant(variants, props, style));
}

function pushAliases(variants, aliases, styles, propKey) {
  Object.entries(aliases).forEach(([alias, canonical]) => {
    const style = styles[canonical];
    if (style) {
      pushVariant(variants, { [propKey]: alias }, style);
    }
  });
}

export function toMuiVariants(recipe) {
  const variants = [];

  if (recipe.intents) {
    Object.entries(recipe.intents).forEach(([intentName, styleFactory]) => {
      pushVariant(variants, { variant: intentName }, styleFactory);
    });
  }

  if (recipe.intentAliases) {
    pushAliases(variants, recipe.intentAliases, recipe.intents, "variant");
  }

  if (recipe.sizes) {
    Object.entries(recipe.sizes).forEach(([sizeName, style]) => {
      pushVariant(variants, { size: sizeName }, style);
    });
  }

  if (recipe.sizeAliases) {
    pushAliases(variants, recipe.sizeAliases, recipe.sizes, "size");
  }

  if (recipe.compounds) {
    recipe.compounds.forEach(({ props, style, legacyProps = [] }) => {
      pushWithAliases(variants, props, legacyProps, style);
    });
  }

  if (recipe.legacyCompounds) {
    recipe.legacyCompounds.forEach(({ props, style }) => {
      pushVariant(variants, props, style);
    });
  }

  return variants;
}
